













import {Component} from 'vue-property-decorator';
import json from '@/data/menu.json';
import authModule from '@/store/modules/common/auth.module';
import {ROLE} from '@/config/enum';
import Mixin from '@/mixin';

@Component({
  name: 'home'
})
export default class Home extends Mixin {
  get menus() {
    if (process.env.VUE_APP_FULL_MENU) return json.menu;
    return json.menu
      .filter(value => {
        return value.active;
      })
      .filter(value =>
        value?.role?.split(',').find(x => x === authModule.user?.role)
      );
  }

  mounted() {
    if (authModule.user?.role === ROLE.Manager.toString()) {
      this.goTo('/reports');
    }
  }
}
